module.exports = __webpack_public_path__ + "img/goal.2a28620c.png";